var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChainId, CurrencyAmount, Token, TradeType } from '@uniswap/sdk-core';
// This file is lazy-loaded, so the import of smart-order-router is intentional.
// eslint-disable-next-line no-restricted-imports
import { AlphaRouter } from '@uniswap/smart-order-router';
import JSBI from 'jsbi';
import { transformSwapRouteToGetQuoteResult } from './transformSwapRouteToGetQuoteResult';
export var AUTO_ROUTER_SUPPORTED_CHAINS = Object.values(ChainId).filter(function (chainId) {
    return Number.isInteger(chainId);
});
function getQuote(_a, routerParams, routerConfig) {
    var type = _a.type, chainId = _a.chainId, tokenIn = _a.tokenIn, tokenOut = _a.tokenOut, amountRaw = _a.amount;
    return __awaiter(this, void 0, void 0, function () {
        var router, currencyIn, currencyOut, baseCurrency, quoteCurrency, amount, swapRoute;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    router = new AlphaRouter(routerParams);
                    currencyIn = new Token(tokenIn.chainId, tokenIn.address, tokenIn.decimals, tokenIn.symbol);
                    currencyOut = new Token(tokenOut.chainId, tokenOut.address, tokenOut.decimals, tokenOut.symbol);
                    baseCurrency = type === 'exactIn' ? currencyIn : currencyOut;
                    quoteCurrency = type === 'exactIn' ? currencyOut : currencyIn;
                    amount = CurrencyAmount.fromRawAmount(baseCurrency, JSBI.BigInt(amountRaw));
                    return [4 /*yield*/, router.route(amount, quoteCurrency, type === 'exactIn' ? TradeType.EXACT_INPUT : TradeType.EXACT_OUTPUT, 
                        /*swapConfig=*/ undefined, routerConfig)];
                case 1:
                    swapRoute = _b.sent();
                    if (!swapRoute)
                        throw new Error('Failed to generate client side quote');
                    return [2 /*return*/, { data: transformSwapRouteToGetQuoteResult(type, amount, swapRoute) }];
            }
        });
    });
}
export function getClientSideQuote(_a, routerParams, routerConfig) {
    var tokenInAddress = _a.tokenInAddress, tokenInChainId = _a.tokenInChainId, tokenInDecimals = _a.tokenInDecimals, tokenInSymbol = _a.tokenInSymbol, tokenOutAddress = _a.tokenOutAddress, tokenOutChainId = _a.tokenOutChainId, tokenOutDecimals = _a.tokenOutDecimals, tokenOutSymbol = _a.tokenOutSymbol, amount = _a.amount, type = _a.type;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, getQuote({
                    type: type,
                    chainId: tokenInChainId,
                    tokenIn: {
                        address: tokenInAddress,
                        chainId: tokenInChainId,
                        decimals: tokenInDecimals,
                        symbol: tokenInSymbol,
                    },
                    tokenOut: {
                        address: tokenOutAddress,
                        chainId: tokenOutChainId,
                        decimals: tokenOutDecimals,
                        symbol: tokenOutSymbol,
                    },
                    amount: amount,
                }, routerParams, routerConfig)];
        });
    });
}
